import { RaffleAdminData, RaffleViewData } from '@/generated/graphql';

export function getRaffleWinnerIds(
  data?:
    | Pick<RaffleViewData, 'raffleWinners' | 'raffleWinner'>
    | Pick<RaffleAdminData, 'raffleWinners' | 'raffleWinner'>
    | null,
): string[] {
  const fromList = (data?.raffleWinners ?? []).filter(
    (id): id is string => typeof id === 'string' && id.length > 0,
  );
  if (fromList.length > 0) {
    return [...new Set(fromList)];
  }
  if (typeof data?.raffleWinner === 'string' && data.raffleWinner.length > 0) {
    return [data.raffleWinner];
  }
  return [];
}
